import { useContext, useMemo } from 'react';

import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

import {
  ColSize,
  ContentSection,
  Form,
  InputNumberForm,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';
import { QUOTATION_BUTTON } from '../../../../../shared';

import { GenericDataFormContext } from '../../../../../shared/contexts';
import { StepFourFormContext } from '../../contexts/StepFourForm';

import { ValidateForm } from '../../../../../../../../../shared/utils';

export const CommercePaymentMethods = () => {
  const validateForm = new ValidateForm();

  const { paymentMethods } = useContext(GenericDataFormContext);

  const {
    commercePaymentMethodsForm,
    commertialConditions,
    setLabelButton,
    clearPrimaFieldsOnFormChange,
    quotationResponse,
  } = useContext(StepFourFormContext);

  const maxVariation = useMemo(
    () => commertialConditions?.puntosDeAumentoExtraPrimaVariable!,
    [commertialConditions]
  );
  const minVariation = useMemo(
    () => -commertialConditions?.puntosDeDisminucionExtraPrimaVariable!,
    [commertialConditions]
  );

  const prevValues = useMemo(
    () => ({
      prevEPVValue:
        quotationResponse?.condicionesComerciales.porRecargoAdminist,
      prevCommissionValue:
        quotationResponse?.condicionesComerciales.porComisionProd,
    }),
    [quotationResponse]
  );

  const onPaymentsMethodFormChange = (valueChanged: { variation: number }) => {
    setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    clearPrimaFieldsOnFormChange();

    if (valueChanged?.variation?.toString().length) {
      const prevCommissionValue = Number(prevValues.prevCommissionValue);
      const prevEPVValue = Number(prevValues.prevEPVValue);

      if (prevCommissionValue !== undefined && prevEPVValue !== undefined) {
        commercePaymentMethodsForm.setFieldValue(
          'extraVariable',
          prevEPVValue + valueChanged.variation
        );
        commercePaymentMethodsForm.setFieldValue(
          'commission',
          prevCommissionValue + valueChanged.variation
        );
      }
    }
  };

  return (
    <Form
      formProps={{
        form: commercePaymentMethodsForm,
        name: 'commerce-payment-methods-form',
        onValuesChange: onPaymentsMethodFormChange,
      }}
    >
      <ContentSection level='h3' title='Forma de pago y comisiones'>
        <RowSize>
          <RowSize>
            <ColSize size={20}>
              <SelectForm
                formProps={{
                  label: 'Forma de pago:',
                  name: 'paymentMethod',
                }}
                selectProps={{ options: paymentMethods }}
              />
            </ColSize>

            <ColSize size={20}>
              <InputNumberForm
                formProps={{
                  label: 'Comisión:',
                  name: 'commission',
                }}
                inputNumberProps={{
                  disabled: true,
                  precision: 2,
                  readOnly: true,
                }}
              />
            </ColSize>

            <ColSize size={20}>
              <InputNumberForm
                formProps={{
                  label: 'Extra prima variable:',
                  name: 'extraVariable',
                }}
                inputNumberProps={{
                  disabled: true,
                  precision: 2,
                  readOnly: true,
                }}
              />
            </ColSize>

            <ColSize size={20}>
              <InputNumberForm
                formProps={{
                  initialValue: 0,
                  label: 'Variación:',
                  name: 'variation',
                  rules: validateForm.generateRules({
                    label: 'variación',
                    rules: [
                      'required',
                      `range:${minVariation}:${maxVariation}`,
                    ],
                  }),
                }}
                inputNumberProps={{
                  controls: {
                    upIcon: <PlusOutlined />,
                    downIcon: <MinusOutlined />,
                  },
                  addonAfter: '%',
                  max: maxVariation,
                  min: minVariation,
                }}
              />
            </ColSize>
          </RowSize>
        </RowSize>
      </ContentSection>
    </Form>
  );
};
